import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaStar, FaRegStar } from "react-icons/fa";
import {
  agregarPelicula,
  eliminarPelicula,
} from "../redux/slices/FavouriteSlice";
import MovieModal from "./MovieModal";
import { SeeMoreButton } from "./SeeMoreButton";

const MovieCard = ({ movie }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const favoritos = useSelector((state) => state.favoritos.peliculas);

  const isFavorite = favoritos.some((fav) => fav.id === movie.id);

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (isFavorite) {
      dispatch(eliminarPelicula(movie));
    } else {
      dispatch(agregarPelicula(movie));
    }
  };

  const handleMoreInfoClick = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  const imageUrl =
    movie.banner || `https://image.tmdb.org/t/p/w500${movie.poster}`;

  return (
    <>
      <div
        className="relative m-4 transition-all duration-300 ease-in-out hover:scale-110 hover:z-10"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="relative p-1 border border-white border-opacity-50 rounded-lg shadow-lg bg-black-800">
          <img
            src= { movie.poster_path
                      ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
                      : movie.poster
                  }
            alt={movie.title}
            className="object-cover w-full h-[200px] md:h-[250px] lg:h-[300px] rounded-lg"
          />
          {isHovered && (
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-black bg-opacity-75 rounded-lg">
              <h3 className="mb-2 text-xs font-bold text-white xl:text-lg 2xl:text-xl lg:text-base md:text-sm">
                {movie.name}
              </h3>
              {movie.release_date && (
                <span>{movie.release_date.split("-")[0]}</span>
              )}
              {movie.runtime && <span>{movie.runtime} min</span>}
              <div className="flex flex-col items-center justify-between lg:flex-row">
                <button
                  onClick={handleFavoriteClick}
                  className="p-2 rounded-full"
                >
                  {isFavorite ? (
                    <FaStar className="text-2xl text-yellow-500" />
                  ) : (
                    <FaRegStar className="text-2xl text-white" />
                  )}
                </button>

                <SeeMoreButton handleMoreInfoClick={handleMoreInfoClick} />
              </div>
            </div>
          )}
        </div>
      </div>
      {showModal && (
        <MovieModal movie={movie} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default MovieCard;
